import { Injectable } from '@angular/core';
import { MixpanelTrackingService } from './mixpanel-tracking.service';
import { AgentInfoProvider } from './agent-info-provider';
import { ImpersonateHeaderService } from './impersonate-header.service';

@Injectable({
  providedIn: 'root'
})
export class MembersPhotoTrackingService extends MixpanelTrackingService {

  constructor(private agentProvider : AgentInfoProvider) {
    super();
    this.setAppName("Members Photo");
    this.init();
  }
  trackMembersPhotoEvent(eventName: string, obj: TrackerGenericObject) {
    this.trackMixPanelEvent(eventName, obj, null);
  }
  trackListingAction(eventName: string, obj: TrackerInventoryObject) {
    this.trackMixPanelEvent(eventName, obj, null);
  }
  trackGuestSearchAction(eventName: string, obj: TrackerGuestSearchObject) {
    this.trackMixPanelEvent(eventName, obj, null);
  }
  trackClickedElement(eventName: string, obj: TrackerElementObject) {
    this.trackMixPanelEvent(eventName, obj, null);
  }
  accessPage() {
    let objTrack = {
      Username: this.agentProvider.get_agent_info().Username,
      AccessType: TrackerInventoryObject.getAccessType(this.agentProvider.get_agent_info().AccessType)
  };

    this.trackMixPanelEvent(TrackerActions.ACCESS_PAGE, objTrack, null);
  }


}
export class TrackerGenericObject {
  AccessType: string;
  ActingOnBehalf: string;
  Action: string;
  MlsNum : string

  constructor(action: string, mlsNum: string,agentProvider : AgentInfoProvider,impersonate : ImpersonateHeaderService) {
    this.AccessType = TrackerInventoryObject.getAccessType(agentProvider.get_agent_info().AccessType);
    this.ActingOnBehalf = impersonate.get_impersonate();
    this.Action = action;
    this.MlsNum = mlsNum;
  }
}

export class TrackerInventoryObject  extends TrackerGenericObject{
  MlsNum: string;
  StatusInventory: string;
  constructor(status: string, action: string, mlsNum: string, agentProvider: AgentInfoProvider, impersonate: ImpersonateHeaderService) {
    super(action,null, agentProvider, impersonate);
    this.StatusInventory = TrackerInventoryObject.getStatusName(status);
    this.MlsNum = mlsNum;
  }

  static getStatusName(status: string) {
    if (status == null)
      return "";
    if (status == '1')
      return "Active, Pending, Active-Contract Listings";
    if (status == '10')
      return "Active, Pending, Active-Contract, Contingent";
    if (status == '2')
      return "Sold";
    if (status == '3')
      return "Expired, Canceled, Hold, Withdrawn";
    return "Incomplete";
  }

  static getAccessType(access: number) {
    if (access == 1)
      return "Agent";
    if (access == 2)
      return "Broker";
    if (access == 3)
      return "Photographer";
    if (access == 4)
      return "Guest";
    return "Staff";
  }
}
export class TrackerGuestSearchObject {
  searchTerm: string;
  constructor(_searchTerm: string) {
    this.searchTerm = _searchTerm;
  }
}
export class ListingActions {
  public static PHOTO_LISTING_UPLOAD = "Photo Listing Upload Clicked";
  public static SHARE_ACTION = "Share Clicked";
  public static HOMESNAP_ACTION = "HomeSnap Clicked";
}
export class TrackerActions {
  public static LISTING_ACCESS ="Listing Access";
  public static LOGO_UPLOAD = "Logo Upload";
  public static PHOTO_UPLOAD = "Photo Upload";
  public static SEARCH_AGENT = "Staff Search Agent";
  public static SEARCH_LISTING = "Staff Search Listing";
  public static ACCESS_PAGE = "User Access Members Photo";
  public static LISTING_WIDGET = "Agent Inventory Access";
  public static PHOTO_WIDGET = "Agent Photo Widget";
  public static LOGO_WIDGET = "Agent Logo Widget";

  public static PHOTO_SPECS_ACTION = "Photo Specs Clicked";
  public static PHOTO_ORDER = "Upload Photos Order";
  public static GUEST_MENU_SEARCH = "Home Login Search"

}
export class TrackerElementObject {
  clickedElement: string;
  component: string;

  constructor(_clickedElement: string, _component:string ) {
    this.clickedElement = _clickedElement;
    this.component = _component;
  }
}
